module.exports = __webpack_public_path__ + "img/2024.6e7a47b0.png";